import { Component, OnInit } from '@angular/core';
import { Utils } from '../utils/utils';

@Component({
  selector: 'app-ruta-entregas',
  templateUrl: './ruta-entregas.component.html',
  styleUrls: ['./ruta-entregas.component.css']
})
export class RutaEntregasComponent implements OnInit {

  constructor(
    private ruta:Utils
  ) { }

  ngOnInit() {
    this.ruta.setRuta();
  }

}
